const loginAndSignUp = {
  loginTips: "Zaten bir HitPaw hesabınız var mı? <1>Giriş yap</1>",
  loginSuccessTips: "Giriş başarılı",
  loginErrorTips: "Giriş başarısız",
  loginAccountOrPasswordErrorTips: "E-posta adresiniz veya şifreniz yanlıştı. Lütfen tekrar deneyin.",
  loginAccountNotExitErrorTips: "E-posta kayıtlı değil",
  signUpTips: "Henüz kayıtlı bir kullanıcı değil misiniz?",
  rememberMe: "Beni hatırla",
  forgotPassword: "Şifrenizi Mi Unuttunuz?",
  forgotPasswordTitle: "Şifremi Unuttum",
  verifyEmailBtn: "E-postayı Doğrula",
  resetPasswordTitle: "Şifreyi sıfırla",
  resetPasswordLabel: "Lütfen şifrenizi sıfırlayın",
  resetPasswordPlaceholder: "Yeni bir şifre girin",
  resetPasswordSuccessTips: "Şifre başarıyla sıfırlandı",
  signUpPrivacyTips: "Kaydolarak, <1>Kullanım Hizmetlerimizi</1> ve <3>Gizlilik Politikamızı</3> kabul etmiş olursunuz",
  loginPrivacyTips: "Devam ederek, <1>Kullanım Hizmetlerimizi</1> ve <3>Gizlilik Politikamızı</3> kabul etmiş olursunuz",
  signUpSuccessTips: "Hesabınız Başarıyla Kaydedildi！",
  getCode: "Kodu Al",
  getCodeSuccessTips: "Posta kutunuza gönderildi, lütfen kontrol edin",
  verificationSuccessTips: "E-posta adresi doğrulaması başarılı oldu",
  surveyTitle: "HitPaw Çevrimiçine Hoş Geldiniz",
  surveyStep1: "<1>Adım 1</1>/4",
  surveyStep2: "<1>Adım 2</1>/4",
  surveyStep3: "<1>Adım 3</1>/4",
  surveyQuestion: "HitPaw'ı kullanma amacınız nedir?",
  surveyThemeQuestion: "Beğendiğiniz modu seçin",
  surveyAnswerOther: "Diğerleri",
  surveyAnswer1: "Yaşam Tarzı Videosu",
  surveyAnswer2: "İş Videosu",
  surveyAnswer3: "Şirket Videosu",
  surveyAnswer4: "Pazarlama Videosu",
  surveyAnswer5: "Sosyal Medya Videosu",
  surveyAnswer6: "Slayt Gösterisi Videosu",
  surveyAnswer7: "Video Aracı",
  surveyAnswer8: "Seyahat Videosu",
  surveyAnswer9: "Düğün Videosu",
  surveyAnswer10: "Doğum Günü Videosu",
  surveyAnswer11: "Bebek Videosu",
  surveyAnswer12: "Hayvan Videosu",
  surveyAnswer13: "Yemek Videosu",
  surveyAnswer14: "Moda Videosu",
  surveyAnswer15: "Tatil Videosu",
  surveyAnswer16: "Spor Videosu",
  surveyAnswer17: "Fotoğraf Videosu",
  surveyAnswer18: "Müzik Videosu",
  surveyAnswerLightMode: "Aydınlık modu",
  surveyAnswerDarkMode: "Karanlık modu",
  surveyNextBtn: "Sonraki",
  surveyBackBtn: "Geri",
  surveyDoneBtn: "Tamamlandı",
  surveyStartBtn: "Başla",
  logoutWarnTips: "Çıkış yapacağınızdan emin misiniz?",
  ContinuewithGoogle: 'Google ile devam',
  Securityverification: 'Güvenlik doğrulaması',
  youraccount: 'Hesabınız',
  alreadyexiststoensurethesecuritypleaseverifyitfirst: 'zaten var, lütfen önce doğrulayın.',
};

export default loginAndSignUp;
